
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.13 2.735v.018l.018.005a6.344 6.344 0 014.494 6.06v1.963c0 2.522.961 4.914 2.707 6.734a.59.59 0 01-.426 1H12.303l-.004.02a3.056 3.056 0 01-2.99 2.44 3.056 3.056 0 01-2.99-2.44l-.003-.02H.696a.59.59 0 01-.426-1 9.685 9.685 0 002.707-6.734V8.818a6.344 6.344 0 014.494-6.06l.018-.005v-.908c0-1.003.817-1.82 1.82-1.82 1.005 0 1.821.817 1.821 1.82v.89zm-1.208-.22l.028.003v-.672a.64.64 0 00-1.28 0v.672l.027-.002a6.384 6.384 0 011.225 0zm-2.352 16h-.036l.012.032c.258.726.95 1.247 1.764 1.247.813 0 1.506-.52 1.763-1.247l.012-.033H7.569zm-5.568-1.221l-.03.04h14.675l-.03-.04a10.853 10.853 0 01-2.155-6.513V8.818A5.158 5.158 0 009.31 3.666a5.158 5.158 0 00-5.152 5.152v1.963c0 2.371-.758 4.639-2.156 6.513z","fill":"#fff","stroke":"#353231","stroke-width":".05"}})])
          )
        }
      }
    